import { VXETable } from 'vxe-table';
import _ from 'lodash';
import { Icon } from 'patsnap-biz';
import { fieldPtIconMappings } from '@/constants/hsTableConfig';
import colorSet from '@/constants/colorSet';
import { useVxeColumnMove } from '@/presentation/pages/detail/basic/hooks/useVxeColumnMove';
function renderHeader(h, renderOpts, params) {
    const { column } = params;
    const prop = _.get(column, 'property');
    const { _column } = renderOpts;
    const columnConfig = _column || {};
    // 自定义字段图表
    const isCustom = _.get(columnConfig, '_props.is_custom');
    let customFieldIcon = null;
    if (isCustom) {
        const field = columnConfig._props || {};
        const colorMap = colorSet.defaults;
        customFieldIcon = (<div class="lite-table__header-cell__field-icon_wrapper">
                {field.field_label_scope === 'SPACE' && <div class="field-icon__triangle"></div>}
                <Icon class="lite-table__header-cell__field-icon" icon={fieldPtIconMappings[field.field_type]} style={{ fill: colorMap[field.field_color || 0], fontSize: '24px' }} data-space-scope={field.field_label_scope}/>
            </div>);
    }
    // 排序
    const sort = _.get(columnConfig, '_sortConfig.sorted');
    let sortBlock = null;
    if (sort) {
        const sortIconClassName = sort.direction.index ? 'icon-max-min' : 'icon-min-max';
        sortBlock = (<div class="lite-table__header-cell__sort">
                <i class={`lite-table__header-cell__sort-arrow iconfont ${sortIconClassName}`}/>
                <div class="lite-table__header-cell__sort-index">{sort.sortIndex + 1}</div>
            </div>);
    }
    // 菜单小三角
    let menuArrow = (<Icon class="lite-table__header-cell__menu-arrow" icon="SolidDropdownOpen" style={{ fontSize: '24px' }} onClick={event => {
            this.$emit('open-col-header-menu', {
                event,
                column: columnConfig,
            });
        }}/>);
    // 如果没有菜单项，隐藏小三角
    const hasSortOption = _.get(columnConfig, '_sortConfig.sortOptions');
    const hasEditDefinitionPermission = _.get(columnConfig, '_props.edit_definition');
    if (prop === 'SORT_SEQ_NUM' || (!hasSortOption && !hasEditDefinitionPermission)) {
        menuArrow = '';
    }
    // 拖拽排序
    const $table = params.$table;
    let columnMoveProps = useVxeColumnMove({
        // @ts-ignore todo 没有这个参数
        renderOpts,
        params,
        cb: ({ fromTargetKey, toTargetKey, type }) => {
            this.$emit('column-move-finish', {
                from: $table.getColumnByField(fromTargetKey),
                to: $table.getColumnByField(toTargetKey),
                position: type === 'LEFT' ? 0 : 1,
            });
        },
    });
    if (prop === 'SORT_SEQ_NUM') {
        // @ts-ignore
        columnMoveProps = {};
    }
    return [
        <div class={`lite-table__header-cell ${isCustom ? 'custom-cell' : ''}`} data-col-key={prop} 
        // @ts-ignore
        domProps={columnMoveProps} title={column.title}>
            {customFieldIcon}
            <span class="lite-table__header-cell__title">{column.title}</span>
            {sortBlock}
            {menuArrow}
        </div>,
    ];
}
const RENDERS = {
    PN: 'PN.render',
    AN_UNSTANDARD: 'AN_UNSTANDARD.render',
    AN_STANDARD: 'AN_STANDARD.render',
    ANC_ADD: 'ANC_ADD.render',
    TITLE: 'TITLE.render',
    ARRAY_LINK: 'ARRAY_LINK.render',
    LEGAL: 'LEGAL.render',
    CITED: 'CITED.render',
    PRIORITY: 'PRIORITY.render',
    INPADOC: 'INPADOC.render',
    COMMENT: 'COMMENT.render',
    PV: 'PV.render',
    SINGLE_LINK: 'SINGLE_LINK.render',
    SORT_SEQ_NUM: 'SORT_SEQ_NUM.render',
    FAMILY_NUM: 'FAMILY_NUM.render',
    ARRAY: 'ARRAY.render',
    CLASSIFICATION: 'CLASSIFICATION.render',
    COUNTRY: 'COUNTRY.render',
    PATENT_TYPE: 'PATENT_TYPE.render',
    EFFICIENCY_SENTENCE: 'EFFICIENCY_SENTENCE.render',
    CLAIM_COUNT: 'CLAIM_COUNT.render',
    CLASSIFICATION_TAG: 'CLASSIFICATION_TAG.render',
    SIMPLE_LEGAL_STATUS: 'SIMPLE_LEGAL_STATUS.render',
    SCORE_T: 'SCORE_T.render',
    NEV: 'NEV.render',
    SAVED_TO_WORKSPACE: 'FOLDERS.render',
};
export const CELL_CONFS = {
    PN: {
        width: 220,
        render: RENDERS.PN,
        filter: false,
    },
    AN: {
        render: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ANC_ADD: {
        render: RENDERS.ANC_ADD,
        width: 240,
    },
    TITLE: {
        width: 300,
        render: RENDERS.TITLE,
    },
    IN: {
        render: RENDERS.ARRAY_LINK,
        width: 200,
    },
    LEGAL_STATUS: {
        render: RENDERS.LEGAL,
        width: 160,
    },
    PRIORITY: {
        render: RENDERS.PRIORITY,
        width: 400,
    },
    ANC: {
        render: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ROOT_COMPANY_ASSIGNEE: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ANS: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ANCS: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ROOT_COMPANY_CURRENT_ASSIGNEE: {
        render: RENDERS.AN_STANDARD,
        width: 200,
    },
    ADC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    TTC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    SEIC: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    SEIC_ALL: {
        render: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    AT: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    ATC: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IN_ST: {
        render: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IPC: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    LOC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    UPC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    CPC: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    CPC_ALL: {
        render: RENDERS.CLASSIFICATION,
        width: 360,
    },
    GBC: {
        render: RENDERS.CLASSIFICATION,
        width: 260,
    },
    CITE_COUNT: {
        render: RENDERS.CITED,
    },
    CITED_COUNT: {
        render: RENDERS.CITED,
    },
    SIMPLE_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
    },
    EXTEND_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
    },
    INPADOC_FAMILY_COUNT: {
        render: RENDERS.INPADOC,
    },
    CHEMICAL_STRUCTURE: {
        // @ts-ignore todo 没有这个属性？
        render: RENDERS.CHEMICAL,
    },
    AN_ADD: {
        isLink: true,
    },
    APN: {
        render: RENDERS.FAMILY_NUM,
        width: 190,
    },
    PV: {
        render: RENDERS.PV,
    },
    APD: {
        sortable: 'custom',
        width: 100,
    },
    PBD: {
        sortable: 'custom',
        width: 105,
    },
    WS_CREATED_AT: {
        width: 100,
    },
    ABST: {
        // @ts-ignore todo 没有这个属性？
        render: RENDERS.ABST,
        width: 600,
    },
    THUMB_120: {
        // @ts-ignore todo 没有这个属性？
        render: RENDERS.THUMB_120,
        tools: ['viewThumb', 'searchImage'],
    },
    COMMENT: {
        width: 250,
        render: RENDERS.COMMENT,
    },
    SORT_SEQ_NUM: {
        render: RENDERS.SORT_SEQ_NUM,
        width: 215,
    },
    C_STRING: {
        width: 250,
    },
    C_OPTION: {
        width: 180,
    },
    C_URL: {
        width: 160,
    },
    WS_ASSIGN_TO: {
        render: RENDERS.ARRAY,
        width: 200,
    },
    EFAM_COUNTRY: {
        render: RENDERS.COUNTRY,
        width: 200,
    },
    SIMPLE_FAMILY_COUNTRY: {
        render: RENDERS.COUNTRY,
        width: 200,
    },
    MCLMS: {
        // @ts-ignore todo 没有这个属性？
        render: RENDERS.MCLMS,
        width: 600,
    },
    PATENT_TYPE: {
        render: RENDERS.PATENT_TYPE,
        width: 100,
    },
    TARGET_SEQUENCE: {
        // @ts-ignore todo 没有这个属性？
        render: RENDERS.TARGET_SEQUENCE,
        width: 324,
    },
    EFFICIENCY_SENTENCE: {
        render: RENDERS.EFFICIENCY_SENTENCE,
        width: 600,
    },
    CLAIM_COUNT: {
        render: RENDERS.CLAIM_COUNT,
        width: 90,
    },
    SCORE_T: {
        render: RENDERS.SCORE_T,
    },
    SIMPLE_LEGAL_STATUS: {
        render: RENDERS.SIMPLE_LEGAL_STATUS,
        width: 200,
    },
    FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    INPADOC_FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    EXTEND_FAMILY_ID: {
        render: RENDERS.FAMILY_NUM,
        width: 224,
    },
    NEV: {
        render: RENDERS.NEV,
        width: 260,
    },
    SAVED_TO_WORKSPACE: {
        render: RENDERS.SAVED_TO_WORKSPACE,
        width: 100,
    },
    AI_TECHNICAL_PROBLEM: {
        width: 600,
    },
    FIRST_FADL_DATE: {
        sortable: 'custom',
        width: 180,
    },
};
const requireRenders = require.context('./', true, /render\.tsx/);
class VXEService {
    constructor() {
        this.cacheOffset = _.debounce((dom = document.body) => {
            const body = dom.querySelector('.vxe-table--body-wrapper.body--wrapper');
            if (!body)
                return;
            this.CACHE_CLIENT_WIDTH = body.clientWidth;
            this.CACHE_CLIENT_HEIGHT = body.clientHeight;
            this.CACHE_SCROLL_WIDTH = body.scrollWidth;
            this.CACHE_SCROLL_HEIGHT = body.scrollHeight;
        }, 200);
        this.tableInstance = null;
        this.rendersMap = new Map();
        this.initRenders();
        this.CACHE_CLIENT_WIDTH = 0;
        this.CACHE_CLIENT_HEIGHT = 0;
        this.CACHE_SCROLL_WIDTH = 0;
        this.CACHE_SCROLL_HEIGHT = 0;
        this.configMap = new Map();
    }
    /**
     * 注册render
     */
    initRenders() {
        _.forEach(requireRenders.keys(), file => {
            const render = requireRenders(file);
            if (render.name) {
                this.rendersMap.set(render.name, render);
                const renderConfig = render.default || render;
                VXETable.renderer.add(render.name, {
                    renderHeader,
                    ...renderConfig,
                });
            }
        });
    }
    computeEditorStyles(row, column) {
        if (!this.tableInstance)
            return;
        const cell = this.tableInstance.getCell(row, column);
        if (!cell)
            return;
        const offsetLeft = cell.offsetLeft;
        const offsetTop = cell.offsetTop;
        const clientWidth = cell.clientWidth;
        const clientHeight = cell.clientHeight;
        const editorHeight = 300;
        const editorWidth = 280;
        const style = {};
        if (this.CACHE_SCROLL_WIDTH - offsetLeft < editorHeight) {
            style.right = '0px';
            style.maxWidth = `${offsetLeft + clientWidth}px`;
        }
        else {
            style.left = '0px';
        }
        if (this.CACHE_SCROLL_HEIGHT - offsetTop < editorWidth) {
            style.bottom = '0px';
            style.maxHeight = `${offsetTop + clientHeight}px`;
        }
        else {
            style.top = '0px';
        }
        return style;
    }
    updateEditorRect(editor, row, column) {
        const styles = this.computeEditorStyles(row, column);
        for (const key in styles) {
            editor.elm.style[key] = styles[key];
        }
        return editor;
    }
    getRenderAttrs(row, column, name) {
        return {
            'cell-row': row.PATENT_ID,
            'cell-col': column.property,
            'cell-render': name,
        };
    }
    updateCellValue(row, column, value) {
        row[column.property] = value;
    }
    _reduceLayer(arr, init = {}) {
        return _.reduce(arr, (acc, cur) => {
            acc[cur.id] = cur.name;
            if (cur.children) {
                acc = this._reduceLayer(cur.children, acc);
            }
            return acc;
        }, init);
    }
    _reduceOption(arr, init = {}) {
        return _.reduce(arr, (result, item) => {
            result[item.option_id] = item.option_text;
            return result;
        }, init);
    }
    clearCustomFieldIdNameMapping(key) {
        if (key) {
            this.configMap.delete(key);
        }
        else {
            this.configMap.clear();
        }
    }
    getCustomFieldIdNameMapping(key, field) {
        if (this.configMap.has(key))
            return this.configMap.get(key);
        if (!field)
            return {};
        let val = {};
        if (field.field_type === 'OPTION') {
            val = this._reduceOption(field.field_option_value);
        }
        else if (field.field_type === 'LAYER') {
            val = this._reduceLayer(field.field_layer_value);
        }
        this.configMap.set(key, val);
        return val;
    }
}
export const service = new VXEService();
